export const PUBLIC_OFFERS_TYPE = 'public-offers';
